import { useEffect } from 'react';
import { useAdminAuth } from '@/contexts/AdminAuthContext';
import { toast } from 'sonner';

const ADMIN_SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes
const WARNING_TIME = 5 * 60 * 1000; // 5 minutes before timeout

export const AdminSessionManager: React.FC = () => {
  const { isAdmin, signOut } = useAdminAuth();

  useEffect(() => {
    if (!isAdmin) return;

    let warningTimer: NodeJS.Timeout;
    let logoutTimer: NodeJS.Timeout;

    const resetTimers = () => {
      clearTimeout(warningTimer);
      clearTimeout(logoutTimer);

      // Set warning timer
      warningTimer = setTimeout(() => {
        toast.warning('Your admin session will expire in 5 minutes. Click anywhere to extend.', {
          duration: 5000,
        });
      }, ADMIN_SESSION_TIMEOUT - WARNING_TIME);

      // Set logout timer
      logoutTimer = setTimeout(() => {
        toast.error('Admin session expired. Please log in again.');
        signOut();
      }, ADMIN_SESSION_TIMEOUT);
    };

    const handleActivity = () => {
      resetTimers();
    };

    // Activity events to monitor
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];

    // Initialize timers
    resetTimers();

    // Add event listeners
    events.forEach(event => {
      document.addEventListener(event, handleActivity);
    });

    return () => {
      clearTimeout(warningTimer);
      clearTimeout(logoutTimer);
      events.forEach(event => {
        document.removeEventListener(event, handleActivity);
      });
    };
  }, [isAdmin, signOut]);

  return null;
};